import React from 'react';

const ListSVG: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <rect x="2" y="4" width="3" height="3" rx="0.5" />
      <rect x="7" y="4" width="15" height="3" rx="1" />

      <rect x="2" y="10.5" width="3" height="3" rx="0.5" />
      <rect x="7" y="10.5" width="15" height="3" rx="1" />

      <rect x="2" y="17" width="3" height="3" rx="0.5" />
      <rect x="7" y="17" width="15" height="3" rx="1" />
    </svg>
  );
};

export { ListSVG };
